import { ContentLayout } from "@/layout";

export const LiveSessions = () => {
  return (
    <ContentLayout className="flex flex-col gap-y-6">
      <h1 className="text-4xl font-semibold">Coming Soon!</h1>
    </ContentLayout>
  );
};
